import { LivestreamPing } from "@/store/modules/livestream/livestream"

export default (pings: LivestreamPing[], p: LivestreamPing) => {
  let i = pings.length
  while (i--) {
    if (pings[i].cat_time <= p.cat_time) break
  }
  return [...pings.slice(0, i + 1), p, ...pings.slice(i + 1)]
}
